export default function ({ store }) {
  console.log('판매알림신청 초기화 플러그인 실행')

  // 로그인 상태 확인 후 판매알림신청 목록 로드
  const checkAndLoadAnc = () => {
    const mbMngNo = store.getters['session/getMbMngNo']
    if (mbMngNo && mbMngNo !== 'undefined' && mbMngNo !== '') {
      store.dispatch('anc/fetchAncList')
    } else {
      console.log('로그인되지 않아 판매알림신청 목록 로드 건너뜀')
    }
  }

  // 초기 로드
  checkAndLoadAnc()

  // HMR 중복 등록 방지: 이전 리스너 제거 후 재등록
  if (window.__ancFocusHandler) {
    window.removeEventListener('focus', window.__ancFocusHandler)
  }
  window.__ancFocusHandler = checkAndLoadAnc
  window.addEventListener('focus', checkAndLoadAnc)

  // mbMngNo 변경 감지 (로그인/로그아웃)
  // 이전 watcher 해제 후 재등록 (HMR 중복 방지)
  if (window.__ancUnwatch) {
    window.__ancUnwatch()
  }
  window.__ancUnwatch = store.watch(
    state => state.session.member.mbMngNo,
    (newMbMngNo, oldMbMngNo) => {
      if (newMbMngNo !== oldMbMngNo) {
        console.log('mbMngNo 변경 감지, 판매알림신청 목록 갱신/초기화')
        store.dispatch('anc/fetchAncList')

        // [DRNQ-2868] 사용자 변경 시 기획전 신청 상태 초기화
        store.commit('curation/CLEAR_APPLIED_STATES')
      }
    }
  )
}
